import repository from "../Repository";

export default {
  async create(screenId, s3objects, bucketName) {
    return await repository.post(
      `file_s3_url`,
      {
        s3objects: s3objects,
        bucket_name: bucketName
      },
      {
        headers: {
          s: screenId
        }
      }
    );
  }
};
